interface ItemDropdownOptions {
  onClick: () => void
}

interface ItemDropdownReturn {
  handleClick: () => void
}

export const useItemDropdown = ({ onClick }: ItemDropdownOptions): ItemDropdownReturn => {
  const handleClick = (): void => {
    onClick()
  }

  return {
    handleClick,
  }
}
